import { RemoteImpersonatePerson } from 'data/usecases';
import { ImpersonatePersonUseCaseInterface } from 'domain/usecases';
import { makeApiUrlImpersonate } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteImpersonatePerson =
  (): ImpersonatePersonUseCaseInterface =>
    new RemoteImpersonatePerson(makeApiUrlImpersonate(), makeAxiosHttpClient());
